module.exports = __webpack_public_path__ + "img/archive.ea913c9f.png";